import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from "rxjs/Observable";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';

import * as globalConst from './../../../../constants';

@Injectable()
export class ReasonOfExtensionEditService {

	private apiUrl = globalConst.baseAPI;

	constructor(private http: Http) {
	}

	loadReasonOfExtension(token, ID) {
		return this.http
		.get(this.apiUrl + "motivoprorrogacao/v1/consultarmotivoprorrogacao/" + ID, JSON.parse(localStorage.getItem('yara.connectionHeader')))
		.map((res: Response) => res.json())
		.catch(e => {
			if (e.status === 401) {
				return Observable.throw('Unauthorized');
			}
		});
	}

	editReasonOfExtension(token, reasonOfExtension: any) {
		return this.http
		.put(this.apiUrl + "motivoprorrogacao/v1/atualizarmotivoprorrogacao", reasonOfExtension, JSON.parse(localStorage.getItem('yara.connectionHeader')))
		.map((res: Response) => res.json())
		.catch(e => {
			if (e.status === 401) {
				return Observable.throw('Unauthorized');
			}
		});
	}

}



// WEBPACK FOOTER //
// ./src/app/reason-of-extension/service/reason-of-extension-edit/reason-of-extension-edit.service.ts